import { render, staticRenderFns } from "./AddOtherDispatchesFrame.vue?vue&type=template&id=fe47d388&scoped=true&"
import script from "./AddOtherDispatchesFrame.vue?vue&type=script&lang=js&"
export * from "./AddOtherDispatchesFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe47d388",
  null
  
)

export default component.exports